export const SET_USER_CREDENTIALS = "SET_USER_CREDENTIALS";
export const SET_USER_FLOW_CREDENTIALS = "SET_USER_FLOW_CREDENTIALS";

export const SET_EMAIL = "SET_EMAIL";
export const SET_USER_EMAIL = "SET_USER_EMAIL";

// export const SET_EVENT_ID = "SET_EVENT_ID";
export const SET_AWARD_ID = "SET_AWARD_ID";

export const SET_REGISTRATION_FORM_ID = "SET_REGISTRATION_FORM_ID"; // New action type

export const SET_ENTRY_FIELD_PAYLOAD = "SET_ENTRY_FIELD_PAYLOAD";
export const UPDATE_ENTRY_FIELD_PAYLOAD = "UPDATE_ENTRY_FIELD_PAYLOAD";
export const RESET_ENTRY_STATE = "RESET_ENTRY_STATE";
export const SET_ENTRY_FORM_ID = "SET_ENTRY_FORM_ID"
export const REMOVE_ENTRY_FORM_ID = "REMOVE_ENTRY_FORM_ID"

export const setUserCredentials = (email, password, first_name) => ({
  type: SET_USER_CREDENTIALS,
  payload: { email, password, first_name },
});

export const setUserFlowCredentials = (email, password) => ({
  type: SET_USER_FLOW_CREDENTIALS,
  payload: { email, password },
});

export const UserDetails = (data) => {
  return {
    type: "USER_DETAILS",
    payload: data,
  };
};

export const userDataAction = (data) => {
  return {
    type: "USER_DATA",
    payload: data,
  };
};

export const userFlowDataAction = (data) => {
  return {
    type: "USERFLOW_DATA",
    payload: data,
  };
};

export const userCheckAction = (data) => {
  return {
    type: "USER_CHECK",
    payload: data,
  };
};

export const userFlowCheckAction = (data) => {
  return {
    type: "USER_FLOW_CHECK",
    payload: data,
  };
};

export const LoaderAction = (data) => {
  return {
    type: "LOADING_DATA",
    payload: data,
  };
};

export const setEmail = (email) => ({
  type: "SET_EMAIL",
  payload: email,
});

export const setUserEmail = (email) => ({
  type: "SET_USER_EMAIL",
  payload: email,
});

// export const setEventId = (id) => ({
//   type: "SET_EVENT_ID",
//   payload: id,
//   console.log("id",id),
// });

// export const setEventId = (id) => {
//   console.log("Dispatched new Event ID:", id); // Log the ID
//   return {
//     type: "SET_EVENT_ID",
//     payload: id,
//   };
// };

export const setEventIdGet = (id) => {
  console.log("Dispatched Event ID:", id); // Log the ID
  return {
    type: "SET_EVENT_ID_GET",
    payload: id,
  };
};

export const removeEventId = (id) =>{
  console.log("removed");
  return{
    type:"REMOVE_EVENT_ID",
    payload:id,
  };
};

export const setAwardId = (awardId) => ({
  type: "SET_AWARD_ID",
  payload: awardId,
});


// Registration Form ID Actions (New)
export const setRegistrationFormId = (registrationFormId) => ({
  type: SET_REGISTRATION_FORM_ID,
  payload: registrationFormId, // Set registrationFormId in the payload
});

export const resetState = () => ({
  type: "RESET_STATE",
});


export const updateFieldPayload = (updatedField) => ({
  type: "UPDATE_FIELD_PAYLOAD",
  payload: {
    dataName: updatedField.dataName,
    updates: updatedField,
  },
});

export const setRoundId = (roundId) => {
  return {
    type: "SET_ROUND_ID",
    payload: roundId,
  };
};

export const setRoundForEvent = (eventId, roundId) => {
  return {
    type: 'SET_ROUND_FOR_EVENT',
    payload: { eventId, roundId },
  };
};

export const removeFieldFromPayload = (dataName) => {
  return {
    type: 'REMOVE_FIELD_FROM_PAYLOAD',
    payload: dataName,
  };
};


export const setEntryFormId = (entryFormId) => ({
  type: SET_ENTRY_FORM_ID,
  payload: entryFormId,
});

export const removeEntryFormId = (entryFormId) => ({
  type: REMOVE_ENTRY_FORM_ID,
  payload: entryFormId,
});


 
export const setEntryFieldPayload = (fieldData) => {
  return (dispatch, getState) => {
    const currentFields = Array.isArray(getState().entry.fieldPayload)
      ? getState().entry.fieldPayload
      : [];
    const updatedFields = [...currentFields, fieldData];

    dispatch({
      type: SET_ENTRY_FIELD_PAYLOAD,
      payload: updatedFields
    });
  };
};

export const updateEntryFieldPayload = (updatedField) => ({
  type: UPDATE_ENTRY_FIELD_PAYLOAD,
  payload: { dataName: updatedField.dataName, updates: updatedField }
});

export const resetEntryState = () => ({
  type: RESET_ENTRY_STATE,
});


export const removeFieldFromEntryPayload = (dataName) => {
  return {
    type: 'REMOVE_FIELD_FROM_ENTRY_PAYLOAD',
    payload: dataName,
  };
};
